/*
 * oddit-section-compare-table
 * Driven entirely by a server-rendered JSON data blob; no network calls at runtime.
 */
(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-compare-table';

  function escapeHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function emptyCell() {
    return '<span class="oddit-section-compare-table__cell-empty">—</span>';
  }

  function findVariant(product, variantId) {
    if (!product || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === variantId) return product.variants[i];
    }
    return product.variants[0] || null;
  }

  function initSection(section) {
    if (!section || section.dataset.odditCompareInit === 'true') return;
    section.dataset.odditCompareInit = 'true';

    var shopifySectionEl = section.closest('[id^="shopify-section-"]');
    if (!shopifySectionEl) return;
    var sectionId = shopifySectionEl.id.replace('shopify-section-', '');

    var dataEl = document.getElementById('oddit-compare-table-data-' + sectionId);
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('[oddit-section-compare-table] Failed to parse data blob for section ' + sectionId, e);
      return;
    }

    var products = (data && data.products) || {};
    var buttonText = (data && data.buttonText) || 'View Product';

    // Per-column state: { productId, variantId }
    var state = { 1: null, 2: null, 3: null };

    function priceHTML(price) {
      if (!price) return '';
      return '<span class="oddit-section-compare-table__card-price-prefix">from</span> ' + escapeHTML(price);
    }

    function renderCard(col, product, variantId) {
      var media = section.querySelector('[data-compare-media="' + col + '"]');
      var card = section.querySelector('[data-compare-card="' + col + '"]');
      if (!card) return;

      if (!product) {
        if (media) { media.innerHTML = ''; media.hidden = true; }
        card.innerHTML = '';
        card.hidden = true;
        return;
      }

      // Circular product image above the dropdown (Figma layout).
      if (media) {
        if (product.image) {
          media.innerHTML =
            '<img class="oddit-section-compare-table__col-image" src="' + escapeHTML(product.image) +
            '" alt="' + escapeHTML(product.title) + '" loading="lazy" width="72" height="72">';
          media.hidden = false;
        } else {
          media.innerHTML = '';
          media.hidden = true;
        }
      }

      card.hidden = false;
      var variant = findVariant(product, variantId);
      var price = variant ? variant.price : '';

      var variantSelectHTML = '';
      if (product.showVariantDropdown && product.variants && product.variants.length > 0) {
        var options = product.variants.map(function (v) {
          var selected = v.id === (variant && variant.id) ? ' selected' : '';
          return '<option value="' + v.id + '"' + selected + '>' + escapeHTML(v.title) + '</option>';
        }).join('');
        variantSelectHTML =
          '<select class="oddit-section-compare-table__variant-select" ' +
          'data-variant-select data-col="' + col + '" ' +
          'aria-label="Select variant for product ' + col + '">' +
          options + '</select>';
      }

      var ctaHref = product.url + (variant && variant.id ? '?variant=' + variant.id : '');

      card.innerHTML =
        '<div class="oddit-section-compare-table__card-price" data-card-price>' + priceHTML(price) + '</div>' +
        variantSelectHTML +
        '<a class="oddit-section-compare-table__card-cta" data-card-cta href="' + escapeHTML(ctaHref) + '" ' +
        'target="_blank" rel="noopener">' +
        '<span>' + escapeHTML(buttonText) + '</span></a>';
    }

    function renderCells(col, product, variantId) {
      // Target the value span so the server-rendered feature label above it is preserved.
      var values = section.querySelectorAll('.oddit-section-compare-table__cell-value[data-col="' + col + '"]');
      values.forEach(function (el) {
        var key = el.getAttribute('data-feature-key');
        if (!product) {
          el.innerHTML = emptyCell();
          return;
        }
        var bucket = (product.metafields && product.metafields[variantId]) || null;
        if (!bucket && product.metafields && product.variants && product.variants[0]) {
          bucket = product.metafields[product.variants[0].id] || null;
        }
        var value = bucket ? bucket[key] : '';
        if (value && String(value).trim() !== '') {
          el.innerHTML = value;
        } else {
          el.innerHTML = emptyCell();
        }
      });
    }

    function selectProduct(col, productId) {
      if (!productId) {
        state[col] = null;
        renderCard(col, null);
        renderCells(col, null);
        return;
      }
      var product = products[productId];
      if (!product) {
        state[col] = null;
        renderCard(col, null);
        renderCells(col, null);
        return;
      }
      var firstVariant = product.variants && product.variants[0];
      var variantId = firstVariant ? firstVariant.id : null;
      state[col] = { productId: productId, variantId: variantId };
      renderCard(col, product, variantId);
      renderCells(col, product, variantId);
    }

    var productSelects = section.querySelectorAll('[data-compare-product-select]');
    productSelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var col = sel.getAttribute('data-index');
        selectProduct(col, sel.value);
      });
    });

    var currentProductId = section.getAttribute('data-current-product-id');
    if (currentProductId && products[currentProductId]) {
      var firstSelect = section.querySelector('[data-compare-product-select][data-index="1"]');
      if (firstSelect) firstSelect.value = currentProductId;
      selectProduct('1', currentProductId);
    }

    section.addEventListener('change', function (e) {
      var target = e.target;
      if (!target || !target.matches || !target.matches('[data-variant-select]')) return;
      var col = target.getAttribute('data-col');
      var variantId = parseInt(target.value, 10);
      var s = state[col];
      if (!s) return;
      var product = products[s.productId];
      if (!product) return;
      s.variantId = variantId;
      var variant = findVariant(product, variantId);
      var priceEl = section.querySelector('[data-compare-card="' + col + '"] [data-card-price]');
      if (priceEl && variant) priceEl.innerHTML = priceHTML(variant.price);
      var ctaEl = section.querySelector('[data-compare-card="' + col + '"] [data-card-cta]');
      if (ctaEl && variant) ctaEl.setAttribute('href', product.url + '?variant=' + variant.id);
      renderCells(col, product, variantId);
    });
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e || !e.target) return;
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) {
      section.dataset.odditCompareInit = 'false';
      initSection(section);
    }
  });
})();
